/**
 * @generated SignedSource<<20744149a6abca00bfe3fbe4782f8e76>>
 * @relayHash 61e4dfda9f4ee5eafd7aa36bd3e9ee64
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ce5423efd579a4621c0f1f58dcc6187e13f9e96f2c1dcfc5c718c7c8d7c1e802

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookDetailQuery } from './PlaybookDetailQuery.graphql';

import checklistStepEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraPlaybookChecklistStepRelayProvider';

const node: PreloadableConcreteRequest<PlaybookDetailQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ce5423efd579a4621c0f1f58dcc6187e13f9e96f2c1dcfc5c718c7c8d7c1e802",
    "metadata": {},
    "name": "PlaybookDetailQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraPlaybookChecklistStepRelayProvider": checklistStepEnabled_provider
    }
  }
};

export default node;
